<template>
  <el-form
    ref="feesForStopMasterForm"
    :model="model"
    :rules="rules"
    label-width="auto"
    label-position="left"
    class="fees-for-stop-master-form"
  >
    <div class="el-form--inline">
      <ChargeYear v-model="chargeYear" label="料金年度"  prop="charge_year" yearType = "reference"  :required="true" :searchCond="true" :disabled="editMode" :autofocus="!editMode" :initialize="true" :tableType = tableType mode = "this" />
      <!-- <BillingYm v-model="billingYm" :required="true" label="年度" :searchCond="searchMode" :mode="billingYmMode" :disabled="editMode" :autofocus="!editMode" /> -->
      <Select v-model="routeCode" label="線別" prop="route_code" :required="!searchMode" :searchCond="searchMode" :disabled="editMode" codeId="ROUTE_CODE" :initialize="true" />
    </div>
    <div class="el-form--inline">
      <Numeric v-model="minWeight" label="最小データ" prop="min_weight"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editMode" />
      <Numeric v-model="maxWeight" label="最大データ" prop="max_weight"
          :required="!searchMode" :searchCond="searchMode" :min="0" :max="9999" :step="1" :disabled="editMode" />
    </div>

    <template v-for="(tableComponent, form_index) in tableComponents">
      <el-divider :key="'el-divider_' + String(form_index)"/>
      <div :key="'div1_' + String(form_index)" class="el-form--inline">
        <div :key="'div2_' + String(form_index)">{{ tableComponent.label }}</div>
        <!-- <div :key="'div3_' + String(form_index)" class="parent_Box">
          <div :key="'div4_' + String(form_index)" class="child_Box">
            <el-checkbox
              v-if="editMode"
              :value="getModelItem(tableComponent.model)"
              @change="onChangeCheckBox($event, tableComponent.model)"
              :key="'checkbox_' + String(form_index)"
            >
              更新対象とする
            </el-checkbox>
          </div>
        </div> -->
      </div>
      <Table
        :key="'table_' + String(form_index)"
        :table-data="getModelItem(tableComponent.tableDataName)"
      >
        <template #columns class="TableColumnComponets">
          <template v-for="(tableColumn, index) in tableColumns(tableComponent.category)">
            <MenuColumn v-if="tableColumn.component == 'MenuColumn'"
              :key="index"
              @copy="copyRow"
              :cbdelete="deleteRow"
            />
            <component v-else-if="tableColumn.component == 'TextColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :maxlength="tableColumn.maxlength"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="tableColumn.disabled"
              :uppercase="tableColumn.uppercase"
              :tableDataName="tableComponent.tableDataName"
            />
            <component v-else-if="tableColumn.component == 'NumericColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :maxlength="tableColumn.maxlength"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="tableColumn.disabled"
              :min="tableColumn.min"
              :max="tableColumn.max"
              :precision="tableColumn.precision"
              :step="tableColumn.step"
              :controls="tableColumn.controls"
              :tableDataName="tableComponent.tableDataName"
            />
            <component v-else-if="tableColumn.component == 'CodeColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :editable="tableColumn.editable"
              :width="tableColumn.width"
              :required="tableColumn.required"
              :placeholder="tableColumn.placeholder"
              :disabled="tableColumn.disabled"
              :initialize="tableColumn.initialize"
              :tableDataName="tableComponent.tableDataName"
              :codeId="tableColumn.codeId"
            />
            <component v-else-if="tableColumn.component == 'CheckBoxColumn'"
              :is="tableColumn.component"
              :key="index"
              v-model="inputItemList(tableComponent.category)[tableColumn.prop]"
              :prop="tableColumn.prop"
              :label="tableColumn.label"
              :width="tableColumn.width"
              :disabled="tableColumn.disabled"
              :tableDataName="tableComponent.tableDataName"
            />
          </template>
        </template>
      </Table>
    </template>
    <template v-if='formMode === "edit" '>
      <el-divider />
      <div class="el-form--inline">
        <DateTime v-model="updatedOn" label="更新日時" prop="updated_on"
            :required="!searchMode" :searchCond="searchMode" :disabled="editMode"
            format="yyyy/MM/dd HH:mm:ss" />
        <Blank />
      </div>
    </template>
    <el-divider />
  </el-form>
</template>

<script>
import ChargeYear from '@/components/molecules/form/select/ChargeYear.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import Select from '@/components/molecules/form/select/Select.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
import AirportCode from '@/components/molecules/form/select/AirportCode.vue'
import ExemptionRate from '@/components/molecules/form/text/ExemptionRate.vue'

export default {
  components: {
    ChargeYear,
    DateTime,
    Select,
    Numeric,
    Blank,
    AirportCode,
    ExemptionRate,
    Table: () => import('@/components/molecules/table/TableEdit.vue'),
    TextColumn: () => import('@/components/molecules/table/column/TextColumn.vue'),
    CodeColumn: () => import('@/components/molecules/table/column/CodeColumn.vue'),
    NumericColumn: () => import('@/components/molecules/table/column/NumericColumn.vue'),
    CheckBoxColumn: () => import('@/components/molecules/table/column/CheckBoxColumn.vue'),
    MenuColumn: () => import('@/components/molecules/table/column/MenuColumn.vue')
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    // billingYmMode: {
    //   type: String,
    //   default: 'search'
    // },
    editDisabledMode: {
      type: Boolean,
      default: false
    },
    tableType: String
  },
  data () {
    return {
      tableComponents: [
        { category: 'detail', label: '停留料金', model: 'detail_update_flag', height: '100', tableDataName: 'details' }
      ],
      detailTableColumns: [
        { component: 'NumericColumn', prop: 'data_range_from', label: 'from', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'data_range_to', label: 'to', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '', disabled: true, min: 0, max: 999999, precision: 0, step: 1 },
        { component: 'NumericColumn', prop: 'charge', label: '単価', width: '100', initialize: '', required: true, editable: true, uppercase: '', maxlength: 6, placeholder: '単価', disabled: false, min: 0, max: 999999, precision: 0, step: 1 },
        // { component: 'CheckBoxColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100' },
        { component: 'CodeColumn', prop: 'flat_charge_flag', label: '定額フラグ', width: '100', initialize: true, required: true, disabled: true, editable: true, codeId: 'FLAT_CHARGE_FLAG' }
        // { component: 'MenuColumn' }
      ],
      detailInputItemList: {}
    }
  },
  computed: {
    chargeYear: {
      get () {
        return this.model.charge_year
      },
      set (chargeYear) {
        const form = { ...this.model }
        form.charge_year = chargeYear
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    minWeight: {
      get () {
        return this.model.min_weight
      },
      set (minWeight) {
        // alert('set')
        const form = { ...this.model }
        form.min_weight = minWeight
        this.$emit('input', form)
      }
    },
    maxWeight: {
      get () {
        return this.model.max_weight
      },
      set (maxWeight) {
        const form = { ...this.model }
        form.max_weight = maxWeight
        this.$emit('input', form)
      }
    },
    updatedOn: {
      get () {
        return this.model.updated_on
      },
      set (updatedOn) {
        const form = { ...this.model }
        form.updated_on = updatedOn
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    }
  },
  mounted () {
    this.detailInputItemList = {}
    for (var i = 0; i < this.detailTableColumns.length; i += 1) {
      this.$set(this.detailInputItemList, this.detailTableColumns[i].prop, '')
    }
  },
  methods: {
    getModelItem (key) {
      return this.model[key]
    },
    onChangeCheckBox (value, key) {
      const form = { ...this.model }
      form[key] = value
      this.$emit('input', form)
    },
    tableColumns (category) {
      switch (category) {
        case 'detail':
          return this.detailTableColumns
      }
    },
    inputItemList (category) {
      switch (category) {
        case 'detail':
          return this.detailInputItemList
      }
    },
    clearFields () {
      this.$refs.feesForStopMasterForm.resetFields()
      // this.billingYm = this.getDefaultBillingYm()
      // if (this.searchMode) {
      //   this.model.start_date_time = null
      //   this.model.end_date_time = null
      //   this.model.manual_data_only = false
      //   this.model.automatic_data_only = false
      // }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.feesForStopMasterForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.fees-for-stop-master-form {
  .el-form--inline {
    display: flex;
    // justify-content: space-between;
    // margin-left: 10px;
  }
  td .el-form-item {
    margin-bottom: 5px !important;
  }
  td .el-form-item__content{
    margin-left: 0% !important;
  }
  td .el-form-item.numeric .el-input-number{
    width: 13em !important;
  }
}
</style>
